var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"m-l-10",on:{"click":function($event){$event.stopPropagation();return _vm.show_sale.apply(null, arguments)}}},[_vm._v(" Venta ")])
}
var staticRenderFns = []

export { render, staticRenderFns }